unit form.main;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, VCL.TMSFNCButton,
  WEBLib.ExtCtrls;

type
  TfrmMain = class(TForm)
    WebScrollBox1: TScrollBox;
    btnAPIProcess: TTMSFNCButton;
    wcbMain: TScrollBox;
    procedure btnAPIProcessClick(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    frm : TForm;
  protected procedure LoadDFMValues; override; end;

var
  frmMain: TfrmMain;

implementation

{$R *.dfm}

uses
  form.APIProcessStatus;

procedure TfrmMain.btnAPIProcessClick(Sender: TObject);
begin
  try
    if Assigned(frm) then
      frm.Free;
  except

  end;

  Application.CreateForm(TfrmAPIProcessStatus, wcbMain.ElementID, frm);
end;

procedure TfrmMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebScrollBox1 := TScrollBox.Create(Self);
  btnAPIProcess := TTMSFNCButton.Create(Self);
  wcbMain := TScrollBox.Create(Self);

  WebScrollBox1.BeforeLoadDFMValues;
  btnAPIProcess.BeforeLoadDFMValues;
  wcbMain.BeforeLoadDFMValues;
  try
    Name := 'frmMain';
    Width := 985;
    Height := 480;
    Align := alClient;
    WebScrollBox1.SetParentComponent(Self);
    WebScrollBox1.Name := 'WebScrollBox1';
    WebScrollBox1.Left := 0;
    WebScrollBox1.Top := 0;
    WebScrollBox1.Width := 145;
    WebScrollBox1.Height := 480;
    WebScrollBox1.Align := alLeft;
    WebScrollBox1.BorderStyle := bsSingle;
    WebScrollBox1.ChildOrder := 1;
    btnAPIProcess.SetParentComponent(WebScrollBox1);
    btnAPIProcess.Name := 'btnAPIProcess';
    btnAPIProcess.Left := 9;
    btnAPIProcess.Top := 9;
    btnAPIProcess.Width := 121;
    btnAPIProcess.Height := 25;
    btnAPIProcess.Font.Charset := DEFAULT_CHARSET;
    btnAPIProcess.Font.Color := clWindowText;
    btnAPIProcess.Font.Height := -12;
    btnAPIProcess.Font.Name := 'Segoe UI';
    btnAPIProcess.Font.Style := [];
    btnAPIProcess.Text := 'API Process Status';
    btnAPIProcess.TabOrder := 0;
    SetEvent(btnAPIProcess, Self, 'OnClick', 'btnAPIProcessClick');
    wcbMain.SetParentComponent(Self);
    wcbMain.Name := 'wcbMain';
    wcbMain.Left := 145;
    wcbMain.Top := 0;
    wcbMain.Width := 840;
    wcbMain.Height := 480;
    wcbMain.Align := alClient;
    wcbMain.BorderStyle := bsSingle;
    wcbMain.ChildOrder := 1;
  finally
    WebScrollBox1.AfterLoadDFMValues;
    btnAPIProcess.AfterLoadDFMValues;
    wcbMain.AfterLoadDFMValues;
  end;
end;

end.